import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { endpoints } from "./endpoints";
import { queryHandler } from "../utils/queryHandler";
import { prepareHeaders } from "../utils/prepareHeaders";
import { ComissionsApiPayload, ComissionsApiResponse } from "./Comission";

export const comissionsApi = createApi({
  reducerPath: "comissionsApi",
  baseQuery: queryHandler(
    fetchBaseQuery({
      prepareHeaders: prepareHeaders,
      baseUrl: process.env.REACT_APP_API,
    })
  ),
  tagTypes: ["ComissionList", "Comission"],
  endpoints(build) {
    return {
      getOneComission: build.query<
        ComissionsApiResponse.GetOne,
        ComissionsApiPayload.GetOne
      >({
        query: (params) => ({
          url: endpoints.getOne.url(params.comissionId),
        }),
        providesTags: ["Comission"],
      }),
      listComissions: build.query<ComissionsApiResponse.List, void>({
        query: () => ({
          url: endpoints.list.url,
        }),
        providesTags: ["ComissionList"],
      }),
      createComission: build.mutation<void, ComissionsApiPayload.Create>({
        invalidatesTags: ["ComissionList"],
        query: (body) => ({
          url: endpoints.create.url,
          method: endpoints.create.method,
          body,
        }),
      }),
      updateComission: build.mutation<void, ComissionsApiPayload.Update>({
        invalidatesTags: ["ComissionList", "Comission"],
        query: ({ id, ...body }) => ({
          url: endpoints.update.url(id),
          method: endpoints.update.method,
          body,
        }),
      }),
    };
  },
});

export const {
  useListComissionsQuery,
  useGetOneComissionQuery,
  useCreateComissionMutation,
  useUpdateComissionMutation,
} = comissionsApi;
